// extracted by mini-css-extract-plugin
export default {"NewsletterForm":"NewsletterForm_NewsletterForm__BQIQc","FormButtons":"NewsletterForm_FormButtons__L-Snu"};